// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__2QT10","shimmer":"styles_shimmer__3MpZW"};